/**
 * Formata um CNPJ adicionando pontos, barras e traço.
 *
 * @param {string} cnpj - O CNPJ a ser formatado.
 * @returns {string} O CNPJ formatado.
 */
function formataCNPJ(cnpj) {
  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
}

/**
 * Formata um CPF adicionando pontos e traço.
 *
 * @param {string} cpf - O CPF a ser formatado.
 * @returns {string} O CPF formatado.
 */
function formataCPF(cpf) {
  return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
}

/**
 * Capitaliza a primeira letra de uma string.
 *
 * @param {string} str - A string a ser capitalizada.
 * @returns {string} A string com a primeira letra em maiúsculo.
 */
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Formata um valor numérico como uma moeda brasileira.
 *
 * @param {number} valor - O valor numérico a ser formatado.
 * @returns {string} O valor formatado como moeda brasileira.
 */
function formataValor(valor) {
  if (isNaN(valor)) {
    return valor;
  }
  var Intl = require("intl");
  require("intl/locale-data/jsonp/pt");

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(valor).replace("R$", "R$ ");;
}

/**
 * Formata um valor numérico como um número decimal.
 *
 * @param {number} valor - O valor numérico a ser formatado.
 * @returns {string} O valor formatado como número decimal.
 */
function formataDecimal(valor) {
  if (isNaN(valor)) {
    return valor;
  }
  var Intl = require("intl");
  require("intl/locale-data/jsonp/pt");

  return new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(valor);
}

/**
 * Converte um arquivo para uma string base64 usando FileReader.
 *
 * @param {File} arquivo - O arquivo a ser convertido.
 * @returns {Promise<string>} Uma Promise que resolve com a string base64.
 * @throws {Error} Se ocorrer um erro durante a leitura do arquivo.
 */
function formataBase64(arquivo) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (e) {
      const base64String = e.target.result;
      resolve(base64String);
    };

    reader.onerror = function (error) {
      reject(new Error("Error reading the file: " + error.message));
    };

    reader.readAsDataURL(arquivo);
  });
}

/**
 * Formata um celular adicionando.
 *
 * @param {string} celular - O celular a ser formatado.
 * @returns {string} O celular formatado.
 */
function formataCelular(celular) {
  return celular
    ? celular.length === 11
      ? celular.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})$/, "($1)$2 $3-$4")
      : celular.length === 10
        ? celular.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3")
        : celular
    : "";
}

/**
 * Formata um CPF ou CNPJ adicionando pontos e traço.
 *
 * @param {string} documento - O documento a ser formatado.
 * @returns {string} O CPF ou CNPJ formatado.
 */
function formatCNPJCPF(documento, exterior = "Estrangeiro") {
  return documento
    ? documento === "99999999999"
      ? exterior
      : documento.length === 11
        ? documento.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4")
        : documento.length === 14
          ? documento.replace(
              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
              "$1.$2.$3/$4-$5"
            )
          : documento
    : "";
}

/**
 * Remove caracteres inválidos de uma string.
 *
 * @param {string} str - A string a ser formatada.
 * @returns {string} A string formatada.
 */
function removeCaracteresInvalidos(str) {
  return str.replace(/[^A-z0-9À-ÿ]/g, "");
}

const Format = {
  formataCNPJ,
  formataCPF,
  capitalize,
  formataValor,
  formataDecimal,
  formataBase64,
  formataCelular,
  removeCaracteresInvalidos,
  formatCNPJCPF,
};
export default Format;
